import Api from '@/axios'

export default {
  getOffers (page, sort) {
    return Api().get(`pages/offers?sort=${sort}&page=${page}`)
  }
}
